const apiAddress = "https://a.viragofarms.com";
// const apiAddress = "https://viragoapi.eiinfi.in";

export default apiAddress;
